import React, { useMemo } from 'react';

import { SlDiscussContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { removeUserTagFromText } from '../../utils/helpers';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { SlHelmet } from '../../../../shared/public/SlHelmet/SlHelmet';

export function QuestionMeta() {
	const { question$: question, replies$: replies } = useContainerData(
		SlDiscussContext,
		SlDataService,
		['question$', 'replies$'],
	);

	const mainEntity = useMemo(() => {
		const acceptedAnswer = replies?.find((reply) => reply.isAccepted);
		const suggestedAnswer = replies
			?.filter((reply) => !reply.isAccepted)
			.map((reply) => ({
				'@type': 'Answer',
				...(reply.message && {
					text: removeUserTagFromText(reply.message),
				}),
				upvoteCount: reply.votes,
			})) || [];

		return {
			'@type': 'Question',
			name: question.title,
			...(question.message && {
				text: removeUserTagFromText(question.message),
			}),
			answerCount: question.answers,
			upvoteCount: question.votes,
			...(acceptedAnswer && {
				acceptedAnswer: {
					'@type': 'Answer',
					...(acceptedAnswer.message && {
						text: removeUserTagFromText(acceptedAnswer.message),
					}),
					upvoteCount: acceptedAnswer.votes,
				},
			}),
			suggestedAnswer,
		};
	}, [replies, question]);

	return (
		<SlHelmet
			title={`${question.title} | Sololearn: Learn to code for FREE!`}
			description={question.message?.substring(0, 169)}
			structuredDataMarkup={`{
                "@context": "https://schema.org",
                "@type": "QAPage",
                "mainEntity": ${JSON.stringify(mainEntity)}
            }`}
		/>
	);
}
